import React from 'react';
import { createPortal } from 'react-dom';

export type ToastType = 'success' | 'error' | 'warning' | 'info';

export interface ToastOptions {
  message: string;
  type?: ToastType;
  duration?: number;
}

interface ToastProps {
  toasts: Array<ToastOptions & { id: string }>;
  onRemove: (id: string) => void;
}

const Toast: React.FC<ToastProps> = ({ toasts, onRemove }) => {
  const getIcon = (type: ToastType) => {
    switch (type) {
      case 'success':
        return <i className="feather-check-circle me-2"></i>;
      case 'error':
        return <i className="feather-x-circle me-2"></i>;
      case 'warning':
        return <i className="feather-alert-triangle me-2"></i>;
      default:
        return <i className="feather-info me-2"></i>;
    }
  };

  const getToastClass = (type: ToastType) => {
    switch (type) {
      case 'success':
        return 'bg-success';
      case 'error':
        return 'bg-danger';
      case 'warning':
        return 'bg-warning';
      default:
        return 'bg-info';
    }
  };

  if (toasts.length === 0) {
    return null;
  }

  const toastContent = (
    <>
      <style>
        {`
          @keyframes slideInRight {
            from {
              transform: translateX(100%);
              opacity: 0;
            }
            to {
              transform: translateX(0);
              opacity: 1;
            }
          }
        `}
      </style>
      <div
        style={{
          position: 'fixed',
          top: '120px',
          right: '20px',
          zIndex: 10001,
          display: 'flex',
          flexDirection: 'column',
          gap: '12px',
          maxWidth: '400px',
          pointerEvents: 'none',
        }}
      >
        {toasts.map((toast) => (
          <div
            key={toast.id}
            className={`card border-0 shadow-lg rounded-xxl p-3 ${getToastClass(toast.type || 'info')}`}
            style={{
              color: '#fff',
              minWidth: '300px',
              animation: 'slideInRight 0.3s ease-out',
              pointerEvents: 'auto',
            }}
          >
            <div className="d-flex align-items-center">
              <div className="flex-shrink-0" style={{ fontSize: '20px' }}>
                {getIcon(toast.type || 'info')}
              </div>
              <div className="flex-grow-1 ms-2">
                <p className="mb-0 fw-600 font-sm text-white">{toast.message}</p>
              </div>
              <button
                type="button"
                className="btn-close btn-close-white ms-2"
                onClick={() => onRemove(toast.id)}
                style={{ opacity: 0.8 }}
                aria-label="Close"
              ></button>
            </div>
          </div>
        ))}
      </div>
    </>
  );

  return createPortal(toastContent, document.body);
};

export default Toast;

